import * as yup from 'yup'

export const commentSchema = yup
  .object({
    comment: yup.string().required(),
    role: yup.string(),
  })
  .required()
